module.exports = __webpack_public_path__ + "static/Shahidh-Muhammed-6fa3cd17dd59275ffa63a08df3c6db37.jpg";